import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { DeckModalProvider } from './contexts/DeckModalContext';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import DeckRequestModal from './components/DeckRequestModal/DeckRequestModal';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton';
import ScrollToTop from './components/ScrollToTop/ScrollToTop';
import Home from './pages/Home/Home';
import About from './pages/About/About';
import AssetManagement from './pages/AssetManagement/AssetManagement';
import InvestorRelations from './pages/InvestorRelations/InvestorRelations';
import Advisory from './pages/Advisory/Advisory';
import Contact from './pages/Contact/Contact';
import InvestorLogin from './pages/InvestorLogin/InvestorLogin';
import AdminLogin from './pages/AdminLogin/AdminLogin';
import InvestorDashboard from './pages/InvestorDashboard/InvestorDashboard';
import AdminDashboard from './pages/AdminDashboard/AdminDashboard';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import Terms from './pages/Terms/Terms';
import Disclaimer from './pages/Disclaimer/Disclaimer';
import StewardshipCode from './pages/StewardshipCode/StewardshipCode';
import GrievanceRedressal from './pages/GrievanceRedressal/GrievanceRedressal';
import Aman from './pages/Aman/Aman';
import FundDeck from './pages/FundDeck/FundDeck';
import Insights from './pages/Insights/Insights';
import './styles/globals.css';

function AppShell() {
  return (
    <DeckModalProvider>
      <ScrollToTop />
      <DeckRequestModal />
      <div className="App">
        <Navbar />
        <main className="app-main" style={{ paddingTop: 64 }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/asset-management" element={<AssetManagement />} />
            <Route path="/investor-relations" element={<InvestorRelations />} />
            <Route path="/advisory" element={<Advisory />} />
            <Route path="/insights/:slug" element={<Insights />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/investor-login" element={<InvestorLogin />} />
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/investor-dashboard" element={<InvestorDashboard />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/disclaimer" element={<Disclaimer />} />
            <Route path="/stewardship-code" element={<StewardshipCode />} />
            <Route path="/grievance-redressal" element={<GrievanceRedressal />} />
            <Route path="/aman" element={<Aman />} />
            <Route path="/fund-deck" element={<FundDeck />} />
          </Routes>
          <Footer />
        </main>
        <WhatsAppButton />
      </div>
    </DeckModalProvider>
  );
}

function App() {
  return (
    <Router>
      <AppShell />
    </Router>
  );
}

export default App;
